<ng-container *ngIf="heading && contentDocuments">
  <section class="mobile-documents">
    <div class="box desktop">
      <div class="box-content">
        <h4 class="box-content__heading">
          <span>{{ heading | translate }}</span>
        </h4>
      </div>
      <div class="box-wrapper">
        <ng-container *ngFor="let item of contentDocuments; let index = index">
          <div class="box-wrapper__element">
            <div class="box-wrapper__element--number"
              ><span>{{ index + 1 }}</span></div
            >
            <div class="box-wrapper__element--image">
              <picture>
                <source [srcset]="item.imageWebp" type="image/webp" />
                <img class="image-layout" [src]="item.image" [alt]="heading | translate" loading="lazy" />
              </picture>
            </div>
            <div class="box-wrapper__element--detail"
              ><span>{{ item.detail | translate }}</span></div
            >
          </div>
        </ng-container>
      </div>
    </div>

    <div class="box mobile">
      <div class="box-content">
        <h4 class="box-content__heading">
          <span>{{ heading | translate }}</span>
        </h4>
      </div>
      <div class="box-wrapper">
        <div class="box-wrapper__navigation">
          <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.prev)"
            ><i class="fas fa-arrow-left"></i
          ></button>

          <ng-container *ngFor="let item of contentDocuments; let index = index">
            <div
              class="navigation-content"
              *ngIf="currentSlide === index + 1"
              [ngClass]="{ active: currentSlide === index + 1 }"
            >
              <span>{{ 'QUOTATION.MOBILE_DOCUMENTS.STEP' | translate }}</span
              ><span>{{ index + 1 }}</span>
            </div>
          </ng-container>

          <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.next)"
            ><i class="fas fa-arrow-right"></i
          ></button>
        </div>
        <ng-container *ngFor="let item of contentDocuments; let index = index">
          <div class="box-wrapper__element" [ngClass]="{ slide: currentSlide === index + 1 }">
            <ng-container *ngIf="currentSlide === index + 1">
              <div class="box-wrapper__element--detail"
                ><span>{{ item.detail | translate }}</span></div
              >
              <div class="box-wrapper__element--image">
                <picture>
                  <source [srcset]="item.imageWebp" type="image/webp" />
                  <img class="image-layout" [src]="item.image" [alt]="heading | translate" loading="lazy" />
                </picture>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</ng-container>
